import {
  Component,
  Input
} from '@angular/core';


export class SkyNavbarItemComponent {
  
  public active: boolean;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-navbar-item',
  template: `<div
    class="sky-navbar-item"
    [ngClass]="{'sky-navbar-item-active': active}"
>
  <ng-content></ng-content>
</div>
`,
  styles: [`.sky-navbar-item {
  display: block;
  font-weight: 600;
  margin-right: 5px;
  height: 100%;
}

.sky-navbar-item /deep/ a,
.sky-navbar-item /deep/ .sky-dropdown-button {
  background-color: transparent;
  border: none;
  color: #a7b1c2;
  display: block;
  padding: 16px 12px;
  text-decoration: none;
  width: 100%;
}

.sky-navbar-item /deep/ .sky-dropdown-menu {
  background-color: #2f4050;
}

.sky-navbar-item /deep/ .sky-dropdown-item {
  color: #a7b1c2;
  display: block;
  font-size: 13px;
  font-weight: normal;
  margin: 0;
}

.sky-navbar-item /deep/ .sky-dropdown-item:hover {
  background-color: #293846;
  color: #ffffff;
}

.sky-navbar-item /deep/ .sky-dropdown-item:hover > /deep/ a,
.sky-navbar-item /deep/ .sky-dropdown-item:hover /deep/ .sky-dropdown-button {
  color: #ffffff;
}

.sky-navbar-item /deep/ .sky-dropdown:hover .sky-dropdown-button,
.sky-navbar-item /deep/ .sky-navbar-item-active,
.sky-navbar-item.sky-navbar-item-active /deep/ > *,
.sky-navbar-item.sky-navbar-item-active /deep/ .sky-dropdown-button {
  background-color: #293846;
  color: #ffffff;
  border-bottom: 4px solid #1c84c6;
  padding-bottom: 12px;
}
`]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'active': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
